import { CareCostBreakdown } from '../components/care-cost-breakdown';
import { StepFrame } from '../components/step-frame';
import { useConsumerClient } from '../hooks/use-consumer-client';
import { useConsumerFlow } from '../hooks/use-consumer-flow';
import type { ConsumerStepProps } from './step-props';

export function BreakdownStep({ clientId }: ConsumerStepProps) {
  const { finish } = useConsumerFlow(clientId);
  const { scenario } = useConsumerClient(clientId);
  if (!scenario) return null;

  return (
    <StepFrame
      step="breakdown"
      title="What’s included in each stage of care?"
      onBack={() => finish('review')}
      help={<p>Home care is priced by the hour for the help you need after family hours. Facilities are priced by the month for your area.</p>}
      primary={{ label: 'Back to my plan', onClick: () => finish('review') }}
    >
      <CareCostBreakdown scenario={scenario} />
    </StepFrame>
  );
}
